<template>
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical form">
    <Form @submit="onBeforeSubmit" :validation-schema="validationSchema" ref="form" :initial-values="formValues">
      <div class="uk-modal-header form-header">
        <span class="uk-text-bold uk-text-large">{{ department && department.id ? "部署編集" : "部署新規作成" }}</span>
      </div>
      <div class="uk-modal-body">
        <FormError :errors="globalErrors" />
        <div class="field">
          <Field name="name" v-slot="{ field }">
            <FieldLabel title="部署名" :required="true" />
            <input class="uk-input" type="text" v-bind="field" />
          </Field>
          <FieldError name="name" />
        </div>
        <div class="field">
          <Field name="parentId" v-slot="{ field }">
            <FieldLabel title="上位部署" :required="true" />
            <select class="uk-select" v-bind="field">
              <option v-for="nodePath in nodePaths" :key="nodePath.id" :value="nodePath.id">
                {{ nodePath.name }}
              </option>
            </select>
          </Field>
          <FieldError name="parentId" />
        </div>
      </div>
      <div class="uk-modal-footer uk-text-right form-action">
        <div>
          <ActionButton title="戻る" class="uk-modal-close" toggleTarget=".department-form-modal" />
        </div>
        <div class="form-action-main">
          <ActionButton title="確定" color="primary" type="submit" :disabled="processing" />
          <ActionButton v-if="department" title="削除" @click="onDeleteButtonClick" color="warn" />
        </div>
      </div>
    </Form>
  </div>
</template>
<style lang="scss" scoped>
@include modal-form;
</style>
<script lang="ts">
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import { DepartmentApi, Department, IdName as NodePaths } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
import { NodeData } from "@/components/molecules/tree/interface";
type FormValues = { name: string; parentId: string };

@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError }
})
export default class DepartmentForm extends FormMixin {
  @Prop({ type: Object }) department?: Department;
  @Prop({ type: Object }) parents?: NodeData | null = null;
  @Prop({ type: Object }) nodePaths?: NodePaths[];
  formName = "部署";
  formValues: FormValues = {
    name: "",
    parentId: "none"
  };
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      name: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "部署名" })),
      parentId: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "親組織" }))
    });
  }
  beforeMount() {
    if (this.department) this.formValues = { name: this.department.name, parentId: this.parents?.id || "none" };
  }
  async onBeforeSubmit(values: FormValues) {
    await this.onSubmit(async () => {
      if (this.department) {
        await new DepartmentApi().updateDepartment({
          updateDepartmentRequest: Object.assign(values, {
            parentId: values.parentId === "none" ? "" : values.parentId
          }),
          departmentId: this.department.id
        });
      } else {
        await new DepartmentApi().createDepartment({
          createDepartmentRequest: Object.assign(values, {
            parentId: values.parentId === "none" ? "" : values.parentId
          })
        });
      }
      this.$emit("submitted");
    });
  }
  async onDeleteButtonClick() {
    this.onDelete(async () => {
      await new DepartmentApi().deleteDepartment({
        departmentId: this.department!.id
      });
    }, [
      "削除された部署は元に戻せません",
      "配下部署も一括削除されます。削除してよろしいですか？",
      "※配下部署を含む部署に従業員、応募者が所属している状態では削除できません。"
    ]);
  }
}
</script>
